// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.students-container {
  border-radius: 10px;
  background-color: #EDf0F1;
  padding: 20px;
  width: 100%;
}
.students-container .carousel-container {
  min-height: 120px;
  padding: 20px 0 10px 0;
  width: 100%;
}
.students-container .carousel-container div.student-icon-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  min-height: 60px;
  min-width: 200px;
}
.students-container .carousel-container span.carousel-name {
  font-size: 0.7rem;
}
.students-container .carousel-container div.blue-bar {
  border-radius: 5px;
  background-color: #0669B3;
  width: 40px;
  height: 4px;
}
.students-container .student-info {
  display: flex;
  justify-content: space-around;
}
.students-container .student-info .marquee {
  min-height: 420px;
}
.students-container .student-info .marquee .marquee-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 450px;
}
.students-container .student-info .marquee .marquee-container .info-card {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background-color: #636161;
  color: white;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-right: 10px;
  padding: 20px;
  width: 100%;
}
.students-container .student-info .marquee .marquee-container .info-card .name {
  font-size: 20px;
  font-weight: 600;
}
.students-container .student-info .marquee .marquee-container .info-card .label {
  font-weight: 500;
}
.students-container .student-info .marquee .marquee-container .info-card .info {
  font-weight: 500;
}
.students-container .student-info .marquee .marquee-container .info-grid {
  display: grid;
  grid-template-columns: 90px 1fr;
  align-items: start;
  gap: 4px 0;
}
.students-container .student-info .marquee .marquee-container .image-container {
  border-radius: 100px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  width: 150px;
  overflow: hidden;
}
.students-container .student-info .marquee .marquee-container .image-container img {
  transform: scale(0.9);
  position: relative;
  top: 20px;
}
.students-container .student-info .marquee .marquee-container .no-image-container {
  margin-top: 10px;
}
.students-container .student-info .student-applications {
  display: block;
}
.students-container .student-info .student-applications .application {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background-color: white;
  margin-bottom: 30px;
  padding: 20px;
}
.students-container .student-info .student-applications .application .application-body {
  color: #444343;
  font-weight: 600;
  font-size: 1rem;
}
.students-container .student-info .student-applications .application .application-body .notice {
  border-radius: 5px;
  border: 1px solid #444343;
  background-color: #FEBF31;
  color: black;
  margin-bottom: 15px;
  padding: 10px;
}
.students-container .student-info .student-applications .application .application-body .sub-body {
  font-size: 1rem;
  font-weight: 600;
  margin-top: 15px;
}
.students-container .student-info .student-applications .application .application-body .sub-body2 {
  font-size: 1rem;
  font-weight: 600;
  margin-top: 15px;
}
.students-container .student-info .student-applications .application .application-body .more-info-button-container {
  display: flex;
  justify-content: center;
  width: 100%;
}
.students-container .student-info .student-applications .application .application-body .more-info-button-container .main-info-button {
  border-radius: 5px;
  background-color: white;
  border: 2px solid #0669B3;
  color: #0669B3;
  font-size: 1rem;
  font-weight: 700;
  height: 30px;
  margin: 20px 5px 0 5px;
  padding: 0 5px;
}
.students-container .student-info .student-applications .application .application-body .more-info-button-container .main-info-button:hover {
  transform: scale(1.015);
  background: #EDf0F1;
}
.students-container .student-info .student-applications .application .application-body .more-info-button-container .main-info-cancel {
  border-radius: 5px;
  background-color: white;
  border: 2px solid #0669B3;
  color: #0669B3;
  font-size: 1rem;
  font-weight: 700;
  height: 30px;
  margin: 20px 5px 0 5px;
  padding: 0 5px;
}
.students-container .student-info .student-applications .application .application-body .more-info-button-container .main-info-cancel:hover {
  transform: scale(1.015);
  background: #EDf0F1;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  min-height: 100px;
  margin: 10px 5px;
  padding: 5px;
  width: 100%;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container {
  border-radius: 10px;
  border: 1px solid #D1D3D4;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  min-height: 90px;
  justify-content: flex-start;
  padding: 5px;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-header {
  border-bottom: 1px solid #EDf0F1;
  width: 100%;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-img-container {
  font-size: 0.7rem;
  margin: 5px;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .WAIT_LIST {
  border-color: orange !important;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .REQUEST {
  border-color: grey !important;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .CANCELLED_REQUEST,
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .DENY_OFFER,
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .DENY_REQUEST {
  border-color: red !important;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .MAKE_OFFER_PENDING,
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body div.WAIT_LIST {
  border-color: orange !important;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .MAKE_OFFER {
  border-color: blue !important;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .ACCEPT_OFFER {
  border-color: #28bfcd !important;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .ENROLLED {
  border-color: green !important;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .NO_RESPONSE {
  border-color: purple !important;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data {
  border-radius: 3px;
  box-shadow: 1px 1px 2px #525151;
  border: 1px solid #A7A9AC;
  display: flex;
  flex-direction: column;
  font-size: 0.85rem;
  justify-content: flex-start;
  margin: 5px;
  max-width: 250px;
  padding: 4px;
  width: 250px;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data .school-card-data-header {
  color: #0669B3;
  font-size: 0.8rem;
  font-style: italic;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data .school-card-status {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data hr {
  border-style: solid;
  border-width: 1px 0 0 0;
  margin: 2px;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data div.status-block {
  height: 100%;
  margin-right: 5px;
  width: 5px;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data div.REQUEST {
  background-color: grey;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data div.CANCELLED_REQUEST,
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data div.DENY_OFFER,
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data div.DENY_REQUEST {
  background-color: red;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data div.MAKE_OFFER_PENDING,
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data div.WAIT_LIST {
  background-color: orange;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data div.MAKE_OFFER {
  background-color: blue;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data div.ACCEPT_OFFER {
  background-color: #28bfcd;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data div.ENROLLED {
  background-color: green;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body .school-card-data-container .school-card-data div.NO_RESPONSE {
  background-color: purple;
}
.students-container .student-info .student-applications .application .application-body .more-info-schools-container .school-card .school-card-container .school-card-body hr {
  border-top: 1px;
  height: 0;
}
.students-container .student-info .student-applications .application .application-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.students-container .student-info .student-applications .application .application-header .left {
  display: flex;
}
.students-container .student-info .student-applications .application .application-header .left .title-container {
  display: flex;
  flex-direction: column;
  font-size: 20px;
  font-weight: 600;
  color: #0669B3;
  margin-top: -10px;
}
.students-container .student-info .student-applications .application .application-header .left .app-buttons-container {
  display: flex;
}
.students-container .student-info .student-applications .application .application-header .left .app-buttons-container .app-buttons {
  border-radius: 5px;
  background: white;
  border: 1px solid #0669B3;
  color: #0669B3;
  font-size: 0.78rem;
  font-weight: 600;
  transition: 0.3s ease;
  padding: 10px;
}
.students-container .student-info .student-applications .application .application-header .left .app-buttons-container .app-buttons:hover {
  transform: scale(1.03);
  background: #C0DEF0;
}
.students-container .student-info .student-applications .application .application-header .status-and-dates .status {
  min-height: 1.2rem;
}
.students-container .student-info .student-applications .application .application-header .status-and-dates {
  text-align: right;
}
.students-container .student-info .student-applications .application .application-header .status-and-dates .dates {
  color: #636161;
  font-size: small;
  margin-top: 5px;
}
.students-container .student-info .student-applications .application .application-header .status-and-dates .dates span.label {
  color: #444343;
  font-weight: 400;
}
.students-container .student-info .student-applications .application .application-header .status-and-dates .dates span {
  font-weight: 600;
}
.students-container .student-info .student-applications .application .application-header .status-and-dates .label {
  color: #444343;
  font-weight: 700;
  margin-right: 5px;
}
.students-container .student-info .student-applications .application .application-header .status-and-dates .info {
  color: #0669B3;
  font-weight: 700;
}
.students-container .student-info .student-applications .application .application-header .status-and-dates .sub-status {
  font-size: 0.6rem;
}
.students-container .student-info .student-applications .application hr {
  border: 1px solid #444343;
  color: #444343;
}

.icon-button {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 60px;
  margin: 0 5px 0 5px;
  object-fit: cover;
  opacity: 0.85;
  text-align: center;
  transform: scale(1);
  transition: all 0.5s ease-in-out;
  width: 60px;
}
.icon-button:hover {
  opacity: 1;
  transform: scale(1.05);
  transition: all 0.5s ease-in-out;
}

.carousel-student {
  opacity: 1;
  transform: scale(1.05);
  transition: all 0.5s ease-in-out;
}

.carousel-button {
  background-color: #EDF0F1;
  border: none;
  font-size: 35px;
  margin: -40px 5px 0 5px;
}

.icon-container {
  border-radius: 5px;
  margin-right: 10px;
  height: 60px;
  width: 60px;
  text-align: center;
}

/* Fade effect */
.fade-style {
  animation: fade-in 1s;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 100;
  }
}
@media screen and (max-width: 1100px) {
  .student-info {
    display: flex;
    flex-direction: column !important;
    align-items: center;
  }
  .info-card {
    margin-bottom: -20px;
  }
}
@media screen and (max-width: 626px) {
  .student-info .application-header {
    display: flex;
    flex-wrap: wrap !important;
  }
  .student-info .application-header .status-and-dates {
    margin-top: 12px;
    width: 100%;
    text-align: left !important;
  }
  .student-info .application-header .status-and-dates .dates {
    font-size: 0.8rem !important;
  }
  .student-info .application-body {
    font-size: 0.8rem !important;
  }
}
@media screen and (max-width: 450px) {
  .info-card {
    width: 75% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/StudentsContainer.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;ECAI,mBDCmC;EACnC,yBDoBI;ECnBJ,aAAA;EACA,WAAA;AAIJ;AAFI;EACI,iBAAA;EACA,sBAAA;EACA,WAAA;AAIR;AAFQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;AAIZ;AADQ;EACI,iBAAA;AAGZ;AAAQ;ECxBJ,kBDyB2C;EACnC,yBDIC;ECHD,WAAA;EACA,WAAA;AAEZ;AAEI;EACI,aAAA;EACA,6BAAA;AAAR;AAEQ;EACI,iBAAA;AAAZ;AAEY;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AAAhB;AAEgB;EC7CZ,mBD8CmD;ECzBnD,2CAAA;ED2BgB,yBDrBZ;ECsBY,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AAApB;AAEoB;EACI,eAAA;EACA,gBAAA;AAAxB;AAGoB;EACI,gBAAA;AADxB;AAIoB;EACI,gBAAA;AAFxB;AAKgB;EACI,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;AAHpB;AAMgB;EC7EZ,oBD8EmD;ECzDnD,2CAAA;ED2DgB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAJpB;AAMoB;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;AAJxB;AAQgB;EACI,gBAAA;AANpB;AAWQ;EACI,cAAA;AATZ;AAWY;ECvGR,mBDwG+C;ECnF/C,2CAAA;EDqFY,uBAAA;EACA,mBAAA;EACA,aAAA;AAThB;AAWgB;EACI,cDnFX;ECoFW,gBAAA;EACA,eAAA;AATpB;AAWoB;ECnHhB,kBDoHuD;EACnC,yBAAA;EACA,yBDlGZ;ECmGY,YAAA;EACA,mBAAA;EACA,aAAA;AATxB;AAYoB;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAVxB;AAaoB;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAXxB;AAcoB;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AAZxB;AAcwB;EC7IpB,kBD8I2D;EACnC,uBAAA;EACA,yBAAA;EACA,cDnHf;ECoHe,eAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAZ5B;AAc4B;EACI,uBAAA;EACA,mBDpIxB;ACwHR;AAgBwB;EC9JpB,kBD+J2D;EACnC,uBAAA;EACA,yBAAA;EACA,cDpIf;ECqIe,eAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAd5B;AAgB4B;EACI,uBAAA;EACA,mBDrJxB;ACuIR;AAmBoB;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;AAjBxB;AAmBwB;ECtLpB,mBDuL2D;EClK3D,2CAAA;EDoKwB,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AAjB5B;AAmB4B;EC9LxB,mBD+L+D;EACnC,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,YAAA;AAjBhC;AAmBgC;EACI,gCAAA;EACA,WAAA;AAjBpC;AAoBgC;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;AAlBpC;AAoBoC;EACI,iBAAA;EACA,WAAA;AAlBxC;AAqBoC;EACI,+BAAA;AAnBxC;AAsBoC;EACI,6BAAA;AApBxC;AAuBoC;;;EAGI,4BAAA;AArBxC;AAwBoC;;EAEI,+BAAA;AAtBxC;AAyBoC;EACI,6BAAA;AAvBxC;AA0BoC;EACI,gCAAA;AAxBxC;AA2BoC;EACI,8BAAA;AAzBxC;AA4BoC;EACI,+BAAA;AA1BxC;AA6BoC;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AA3BxC;AA6BwC;EChQpC,kBDiQ2E;ECxO3E,+BAAA;ED0OwC,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AA3B5C;AA6B4C;EACI,cDhPnC;ECiPmC,iBAAA;EACA,kBAAA;AA3BhD;AA8B4C;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AA5BhD;AA+B4C;EACI,mBAAA;EACA,uBAAA;EACA,WAAA;AA7BhD;AAgC4C;EACI,YAAA;EACA,iBAAA;EACA,UAAA;AA9BhD;AAiC4C;EACI,sBAAA;AA/BhD;AAkC4C;;;EAGI,qBAAA;AAhChD;AAmC4C;;EAEI,wBAAA;AAjChD;AAoC4C;EACI,sBAAA;AAlChD;AAqC4C;EACI,yBAAA;AAnChD;AAsC4C;EACI,uBAAA;AApChD;AAuC4C;EACI,wBAAA;AArChD;AA0CoC;EACI,eAAA;EACA,SAAA;AAxCxC;AAgDgB;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;AA9CpB;AAgDoB;EACI,aAAA;AA9CxB;AAgDwB;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDhUf;ECiUe,iBAAA;AA9C5B;AAiDwB;EACI,aAAA;AA/C5B;AAiD4B;ECrWxB,kBDsW+D;EACnC,iBAAA;EACA,yBAAA;EACA,cD3UnB;EC4UmB,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;AA/ChC;AAkDgC;EACI,sBAAA;EACA,mBDrVxB;ACqSZ;AAuDwB;EACI,kBAAA;AArD5B;AAmDoB;EAKI,iBAAA;AArDxB;AAuDwB;EACI,cDrWpB;ECsWoB,gBAAA;EACA,eAAA;AArD5B;AAuD4B;EACI,cDzWvB;EC0WuB,gBAAA;AArDhC;AAwD4B;EACI,gBAAA;AAtDhC;AA0DwB;EACI,cDnXnB;ECoXmB,gBAAA;EACA,iBAAA;AAxD5B;AA2DwB;EACI,cDvXf;ECwXe,gBAAA;AAzD5B;AA4DwB;EACI,iBAAA;AA1D5B;AA+DgB;EACI,yBAAA;EACA,cDrYX;ACwUT;;AAoEA;EACI,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,WAAA;AAjEJ;AAmEI;EACI,UAAA;EACA,sBAAA;EACA,gCAAA;AAjER;;AAqEA;EACI,UAAA;EACA,sBAAA;EACA,gCAAA;AAlEJ;;AAqEA;EACI,yBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;AAlEJ;;AAqEA;ECzcI,kBD0cmC;EACnC,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAlEJ;;AAqEA,gBAAA;AACA;EACI,qBAAA;AAlEJ;;AAqEA;EACI;IACI,UAAA;EAlEN;EAqEE;IACI,YAAA;EAnEN;AACF;AAuEA;EACI;IACI,aAAA;IACA,iCAAA;IACA,mBAAA;EArEN;EAwEE;IACI,oBAAA;EAtEN;AACF;AAyEA;EAEQ;IACI,aAAA;IACA,0BAAA;EAxEV;EA0EU;IACI,gBAAA;IACA,WAAA;IACA,2BAAA;EAxEd;EA0Ec;IACI,4BAAA;EAxElB;EA6EM;IACI,4BAAA;EA3EV;AACF;AA+EA;EACI;IACI,qBAAA;EA7EN;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
